import React, { useEffect } from 'react';
import { useParams } from 'react-router';

import { Box, Chip, Stack, Tooltip, Typography } from '@mui/material';
import { JBColors } from '@bjb-gcrm/gcrm-frontend-components';
import { useFetchSanctionsInfo } from 'hooks/queries/useFetchSanctionsInfo';
import { assertNotNullOrUndefined } from 'utils/utils';
import { ClmPortalIncomingPostMessageTypes } from 'utils/postMessageUtil';
import { useRuntimeConfig } from 'config/useRuntimeConfig';

export const SanctionsPartnerType = () => {
  const { id: techId } = useParams<{ id: string }>();
  assertNotNullOrUndefined(techId);
  const runtimeConfig = useRuntimeConfig();
  const isSanctionsFeatureEnabled = runtimeConfig?.configData?.featureFlags?.sanctionsInfo?.enabled ?? false;
  const { data: sanctionsInfo, refetch } = useFetchSanctionsInfo(techId, isSanctionsFeatureEnabled);
  const sanctionsPartnerTypeList = sanctionsInfo?.sanctionPartnerTypes;

  useEffect(() => {
    window.addEventListener('message', handleMessage, false);

    function handleMessage(event: any) {
      const { message } = event.data;
      if (message === ClmPortalIncomingPostMessageTypes.UPDATE_SANCTIONS_INFO && isSanctionsFeatureEnabled) {
        void refetch();
      }
    }

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [refetch, techId, isSanctionsFeatureEnabled]);

  if (!isSanctionsFeatureEnabled || !sanctionsPartnerTypeList || sanctionsPartnerTypeList.length === 0) {
    return <></>;
  }
  const visible = (sanctionsPartnerTypeList ?? []).slice(0, 2);
  const nonVisibleCount = Math.max(0, (sanctionsPartnerTypeList?.length ?? 0) - 2);
  return (
    <Tooltip
      arrow
      title={
        <Typography
          variant="body2"
          component="span"
          sx={{
            whiteSpace: 'pre-wrap',
            textTransform: 'capitalize',
            color: JBColors.white,
          }}
        >
          {sanctionsPartnerTypeList?.join(', ')}
        </Typography>
      }
      placement="bottom-start"
      id="sanctions-partner-type-tooltip-id"
      disableHoverListener={false}
    >
      <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
        {visible.map((sanctionType: string, index) => (
          <Stack direction="row" key={'sanctions-partner-type-row-' + index}>
            <Chip
              key={sanctionType}
              label={sanctionType}
              size="small"
              sx={{
                border: 1,
                borderColor: JBColors.support.red[100],
                backgroundColor: JBColors.support.red[20],
                color: JBColors.support.red[120],
                textTransform: 'uppercase',
                fontSize: '9px',
                height: '14px',
                justifyContent: 'left',
                width: 'fit-content',
                lineHeight: '10px',
              }}
            />
            {index == 1 && nonVisibleCount > 0 && (
              <Typography variant="body2" sx={{ color: JBColors.support.red[100], fontSize: '9px', marginLeft: '4px' }}>
                +{nonVisibleCount}
              </Typography>
            )}
          </Stack>
        ))}
      </Box>
    </Tooltip>
  );
};
